import { APIClient } from '@/services'
import { Navigator, PageLoading } from '@/components'
import React from 'react'

export const AuthGuard = ({ children }) => {
  const { profile, loginResolved } = APIClient.Session.useSession()

  if (!profile?.id && loginResolved) {
    return <Navigator.Redirect to='Home' />
  }

  if (!loginResolved) return <PageLoading />

  return <>{children}</>
}
